import * as React from "react";
import {Transition} from "react-transition-group";

import {FComponent} from "@Common/react/f-component";

interface P {
    show: boolean;
    retain: any;
    next: (value: {
        state: "init"|"entering"|"entered"|"exiting"|"exited",
        retain: any,
    }) => JSX.Element;
}
interface S {
    show: boolean;
}
export class ShowTransition extends FComponent<P,S> {
    constructor(props, context) {
        super(props, context);

        this.state = {
            show: props.show,
        };
        this.onChanged(() => this.props.show !== this.state.show && setTimeout(() => {
            this.setState({show: this.props.show});
        }, 10));
    }

    retain = null;

    render() {
        const {next, show, retain} = this.props;

        return (
            <Transition
                in={show}
                timeout={300}
                unmountOnExit
            >
                {(state) => {
                    if (show) {
                        this.retain = retain;
                    }
                    return next({
                        state: !this.state.show && show ? "init" : state,
                        retain: this.retain,
                    });
                }}
            </Transition>
        );
    }
}
